import * as actions from './LineupsActions'

export default (state = { ...actions.LINEUPS_INITIAL_STATE }, action = {}) => {
  switch (action.type) {
    case actions.LINEUPS_FETCH: {
      return { ...state, key: action.payload.id, loaded: false, loading: true }
    }
    case actions.LINEUPS_FETCH_CANCELED: {
      return { ...state, key: null, loading: false }
    }
    case actions.LINEUPS_FETCH_ERROR: {
      return { ...state, ...action.payload, loaded: true, loading: false }
    }
    case actions.LINEUPS_FETCH_FULFILLED: {
      return { ...state, ...action.payload, loaded: true, loading: false }
    }
    default:
  }
  return state
}
